module.exports = __webpack_public_path__ + "static/img/cCT2.5c8869e1.png";